import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { track } from 'core/helpers/analytics';
import { AssurityLifeModal } from 'common/components/assurity-life-modal/assurity-life-modal';
import { AssurityOffer } from 'common/components/assurity-offer/assurity-offer';
import Section from 'core/components/section';
import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import PropTypes from 'prop-types';

export const CustomerAdditionalOffersSection = observer(function CustomerAdditionalOffersSection({
  assurityTermLife = false,
  assurityTermLifeData
}) {
  const {
    account: { policies, id },
    additionalOffers
  } = useStore();
  const {
    user: { affinityCode }
  } = useSession();
  const policy = policies.getRecentPolicy(); // Using getRecentPolicy() here as per discussion in issue #21742 - additional offers don't require an active policy
  const webUserId = policy?.webUserId;
  const location = window.location.href;

  useEffect(() => {
    if (webUserId && webUserId !== additionalOffers?.webUserId) {
      additionalOffers.getAdditionalOfferData(webUserId);
    }
  }, [webUserId, additionalOffers]);

  const [showAssurityTermLifeModal, setShowAssurityTermLifeModal] = useState(false);

  const allPeople = policies.list.reduce(
    (acc, policy) => [
      ...acc,
      ...(policy.policyDetails.people || []),
      ...(policy.policyDetails.drivers || []),
      ...(policy.policyDetails.nonDrivers || [])
    ],
    []
  );

  const openAssurityTermLifeModal = () => {
    setShowAssurityTermLifeModal(true);
    track('Agent Clicked View Life Offer', {
      URL: location,
      preBindId: webUserId,
      accountId: id,
      affinityCode
    });
  };

  return (
    <>
      <Section title="Additional Offers">
        {assurityTermLife && assurityTermLifeData?.eligibleLifeOffers?.length > 0 && (
          <AssurityOffer
            assurityTermLifeData={assurityTermLifeData}
            allPeople={allPeople}
            onOpenOffersClicked={openAssurityTermLifeModal}
          />
        )}
      </Section>
      {showAssurityTermLifeModal && (
        <AssurityLifeModal
          assurityData={assurityTermLifeData}
          open={showAssurityTermLifeModal}
          onClose={() => setShowAssurityTermLifeModal(false)}
          people={allPeople}
        />
      )}
    </>
  );
});

CustomerAdditionalOffersSection.propTypes = {
  assurityTermLife: PropTypes.bool,
  assurityTermLifeData: PropTypes.object
};
